import React from 'react';
import * as S from './styles';

export interface AuthPageLayoutProps {
  children: React.ReactNode;
  hideHeadlinerLogo?: boolean;
}

const AuthPageLayout: React.FC<AuthPageLayoutProps> = ({
  children,
  hideHeadlinerLogo = false,
}) => {
  return (
    <S.Background>
      <S.Container
        align="center"
        justify="center"
        orientation="vertical"
        space={0}
      >
        {!hideHeadlinerLogo && <S.Logo />}
        {children}
      </S.Container>
    </S.Background>
  );
};
export default AuthPageLayout;
